import ApiService from "../../api/api.service";
import { GET_MUTUAL_FUND_DATA , GET_LUMPSUM_INVESTMENT_FORM_DATA, GET_SCHEME_NAME_DATA, 
	GET_SCHEME_NAME_DETAIL, DELETE_MUTUALFUND_DATA, SAVE_MUTUALFUND_DATA, GET_LUMPSUM_INVESTMENT_EDIT_FORM_DATA, 
	GET_SYSTEMATIC_INVESTMENT_PLAN_FORM_DATA, GET_EDIT_SYSTEMATIC_INVESTMENT_FORM_DATA, GET_MUTUAL_FUND_GRAPH_DATA } from "../actions.type";
	const getDefaultMutualState = () => {
		return {

			mutualFundData: {},
			lumpsumInvestmentFormData: {},
			mutualFundCompanyData: {},
			schemeNameData: {},
			schemeNameDetail: {},
			lumpsumInvestmentEditFormData: {},
			systematicInvestmentPlanData: {},
			systematicInvestmentEditFormData: {},
			mutualFundGraphData: {},

		}
	};

	const state = getDefaultMutualState();

	const getters = {

		allMutualFundData(state) {
			return state.mutualFundData;
		},

		getLumpsumInvestmentFormData(state) {
			return state.lumpsumInvestmentFormData;
		},

		getMutualFundCompanyData(state) {
			return state.mutualFundCompanyData;
		},

		getSchemeNameData(state) {
			return state.schemeNameData;
		},

		getSchemeNameDetail(state) {
			return state.schemeNameDetail;
		},

		getLumpsumInvestmentEditFormData(state) {
			return state.lumpsumInvestmentEditFormData;
		},

		getSytematicInvestmentPlanData(state) {
			return state.systematicInvestmentPlanData;
		},

		getSystematicInvestmentEditFormData(state) {
			return state.systematicInvestmentEditFormData;
		},

		getMutualFundGraphData(state) {
			return state.mutualFundGraphData;
		},
	};

	const mutations = {

		setMutualFundData (state, data) {
			state.mutualFundData = data
		},

		setLumpsumInvestmentFormData (state, data) {
			state.lumpsumInvestmentFormData = data
		},

		setMutualFundCompanyData (state, data) {
			state.mutualFundCompanyData = data
		},

		setSchemeNameData (state, data) {
			state.schemeNameData = data
		},

		setSchemeNameDetail (state, data) {
			state.schemeNameDetail = data
		},

		setLumpsumInvestmentEditFormData (state, data) {
			return state.lumpsumInvestmentEditFormData = data;
		},

		setSytematicInvestmentPlanData (state, data) {
			return state.systematicInvestmentPlanData = data;
		},

		setSystematicInvestmentEditFormData (state, data) {
			return state.systematicInvestmentEditFormData = data;
		},

		setMutualFundGraphData (state, data) {
			return state.mutualFundGraphData = data;
		},

	};


	const actions = {

		[GET_MUTUAL_FUND_DATA](context, credentials) {
			return new Promise((resolve, reject) => {
				ApiService.setHeader();

				ApiService.post(credentials.api, credentials.data)
				.then(({ data }) => {
					if (data.message == 'Unauthenticated') {
						window.location.replace('/');
					}
					context.commit('setMutualFundData',data);
					resolve();
				})
				.catch(({ response }) => {
					console.log("Something went wrong");
				});
			})
			.catch(response => {
				console.log(response,'post');
				if(response.logout == true)
				{

					window.location.replace('/');

				}
				console.log("Something went wrong");
			});
		},

		[GET_LUMPSUM_INVESTMENT_FORM_DATA](context, credentials) {
			return new Promise((resolve, reject) => {
				ApiService.setHeader();

				ApiService.post(credentials.api, credentials.data)
				.then(({ data }) => {
					if (data.message == 'Unauthenticated') {
						window.location.replace('/');
					}

					data.data.master_data.forEach(element => {

						if (element.MutualFundCompany) {
							context.commit('setMutualFundCompanyData',element.MutualFundCompany);
						}

					});

					context.commit('setLumpsumInvestmentFormData',data);
					resolve();
				})
				.catch(({ response }) => {
					console.log("Something went wrong");
				});
			})
			.catch(response => {
				console.log(response,'post');
				if(response.logout == true)
				{

					window.location.replace('/');

				}
				console.log("Something went wrong");
			});
		},

		[GET_SCHEME_NAME_DATA](context, credentials) {
			return new Promise((resolve, reject) => {
				ApiService.setHeader();

				ApiService.post(credentials.api, credentials.data)
				.then(({ data }) => {
					if (data.message == 'Unauthenticated') {
						window.location.replace('/');
					}

					context.commit('setSchemeNameData',data);
					resolve();
				})
				.catch(({ response }) => {
					console.log("Something went wrong");
				});
			})
			.catch(response => {
				console.log(response,'post');
				if(response.logout == true)
				{

					window.location.replace('/');

				}
				console.log("Something went wrong");
			});
		},

		[GET_SCHEME_NAME_DETAIL](context, credentials) {
			return new Promise((resolve, reject) => {
				ApiService.setHeader();

				ApiService.post(credentials.api, credentials.data)
				.then(({ data }) => {
					if (data.message == 'Unauthenticated') {
						window.location.replace('/');
					}

					context.commit('setSchemeNameDetail',data);
					resolve();
				})
				.catch(({ response }) => {
					console.log("Something went wrong");
				});
			})
			.catch(response => {
				console.log(response,'post');
				if(response.logout == true)
				{

					window.location.replace('/');

				}
				console.log("Something went wrong");
			});
		},

		[DELETE_MUTUALFUND_DATA](context, credentials) {
			return new Promise((resolve, reject) => {
				ApiService.setHeader();

				ApiService.post(credentials.api, credentials.data)
				.then(({ data }) => {
					if (data.message == 'Unauthenticated') {
						window.location.replace('/');
					}
					
					resolve();
				})
				.catch(({ response }) => {
					console.log("Something went wrong");
				});
			})
			.catch(response => {
				console.log(response,'post');
				if(response.logout == true)
				{

					window.location.replace('/');

				}
				console.log("Something went wrong");
			});
		},

		[SAVE_MUTUALFUND_DATA](context, credentials) {
			return new Promise((resolve, reject) => {
				ApiService.setHeader();

				ApiService.post(credentials.api, credentials.data)
				.then(({ data }) => {
					if (data.message == 'Unauthenticated') {
						window.location.replace('/');
					}
					
					resolve();
				})
				.catch(({ response }) => {
					console.log("Something went wrong");
				});
			})
			.catch(response => {
				console.log(response,'post');
				if(response.logout == true)
				{

					window.location.replace('/');

				}
				console.log("Something went wrong");
			});
		},

		[GET_LUMPSUM_INVESTMENT_EDIT_FORM_DATA](context, credentials) {
			return new Promise((resolve, reject) => {
				ApiService.setHeader();

				ApiService.post(credentials.api, credentials.data)
				.then(({ data }) => {
					if (data.message == 'Unauthenticated') {
						window.location.replace('/');
					}

					data.data.master_data.forEach(element => {

						if (element.MutualFundCompany) {
							context.commit('setMutualFundCompanyData',element.MutualFundCompany);
						}

					});

					context.commit('setLumpsumInvestmentEditFormData',data);

					resolve();
				})
				.catch(({ response }) => {
					console.log("Something went wrong");
				});
			})
			.catch(response => {

				if(response.logout == true)
				{

					window.location.replace('/');

				}
				console.log("Something went wrong");
			});
		},

		[GET_SYSTEMATIC_INVESTMENT_PLAN_FORM_DATA](context, credentials) {
			return new Promise((resolve, reject) => {
				ApiService.setHeader();

				ApiService.post(credentials.api, credentials.data)
				.then(({ data }) => {
					if (data.message == 'Unauthenticated') {
						window.location.replace('/');
					}

					data.data.master_data.forEach(element => {

						if (element.MutualFundCompany) {
							context.commit('setMutualFundCompanyData',element.MutualFundCompany);
						}

					});

					context.commit('setSytematicInvestmentPlanData',data);

					resolve();
				})
				.catch(({ response }) => {
					console.log("Something went wrong");
				});
			})
			.catch(response => {

				if(response.logout == true)
				{

					window.location.replace('/');

				}
				console.log("Something went wrong");
			});
		},

		[GET_EDIT_SYSTEMATIC_INVESTMENT_FORM_DATA](context, credentials) {
			return new Promise((resolve, reject) => {
				ApiService.setHeader();

				ApiService.post(credentials.api, credentials.data)
				.then(({ data }) => {
					if (data.message == 'Unauthenticated') {
						window.location.replace('/');
					}

					data.data.master_data.forEach(element => {

						if (element.MutualFundCompany) {
							context.commit('setMutualFundCompanyData',element.MutualFundCompany);
						}

					});

					context.commit('setSystematicInvestmentEditFormData',data);

					resolve();
				})
				.catch(({ response }) => {
					console.log("Something went wrong");
				});
			})
			.catch(response => {

				if(response.logout == true)
				{

					window.location.replace('/');

				}
				console.log("Something went wrong");
			});
		},

		[GET_MUTUAL_FUND_GRAPH_DATA](context, credentials) {
			return new Promise((resolve, reject) => {
				ApiService.setHeader();

				ApiService.post(credentials.api, credentials.data)
				.then(({ data }) => {

					if (data.message == 'Unauthenticated') {
						window.location.replace('/');
					}

					context.commit('setMutualFundGraphData',data);

					resolve();
				})
				.catch(({ response }) => {
					console.log("Something went wrong");
				});
			})
			.catch(response => {

				if(response.logout == true)
				{

					window.location.replace('/');

				}

				console.log("Something went wrong");
				
			});
		},

	};

	export default {
		getters,
		actions,
		mutations,
		state
	}